/**
 * ============================================================================
 * USER / TENANT SERVICE: WhatsApp Templates (Sheets 19 & 20)
 * ============================================================================
 * Purpose:
 *   Handles WhatsApp Cloud API approved templates (`tbl_templates`),
 *   Meta template sync by WABA ID, and submission history requests (`tbl_template_creates`).
 *
 * Database Scope:
 *   Tenant Database (`digi_user_<id>`)
 * ============================================================================
 */

import api from "../../core/services/api";
import { createCrudService } from "../../core/services/crudServiceFactory";

const baseTemplateService = createCrudService("tenant/templates");
const createSubmissionsService = createCrudService("tenant/template-creates");

const templateService = {
  ...baseTemplateService,
  submissions: createSubmissionsService,
  getWabaIds: (params = {}) => api.get("/tenant/templates/waba-ids", { params }),
  syncTemplates: (payload = {}) => api.post("/tenant/templates/sync", payload),
  getTemplates: (params = {}) => baseTemplateService.get(params),
};

export default templateService;
